import { FormDataConsumer } from "react-admin";
import React, { Children, cloneElement } from 'react';
import { anyMandatory, anyNotExpected, isRequired, shouldBeRendered } from "../validation/fieldValidation";
import { hasFieldData } from "../validation/fieldValidation";

import {
    isInterrestrateActive,
    isInterrestrateRequired,
    isInterrestrateVisible,
    isExcercisePriceActive,
    isExcercisePriceVisible,
    isExcercisePriceRequired
} from "../validation/optionalFieldsSpecialCases";

/**
 * This Component checks if its child should be rendered and be indicated as required (Asterisk)
 *  based on the InstrumentCategory.
 */
const ConditionalInput = ({ children, ...props }) => {

    const childElement = Children.only(children);
    const source = props.source;
    const possiblyNotExpected: boolean = anyNotExpected(source);
    const possibleMandatory: boolean = anyMandatory(source);

    if (props.resource === 'isin' && (possiblyNotExpected || possibleMandatory)) {
        return <FormDataConsumer {...props}>
            {({ formData }) => {
                const field = formData[source];
                const hasData = hasFieldData(field);

                const interestActive = isInterrestrateActive(source, formData);
                const exerciseActive = isExcercisePriceActive(source, formData);

                const normallyVisible = shouldBeRendered(source, formData.instrumentCategory, formData.interestType, formData.preliminaryTerms, formData.isinStatus, formData.cfiCode) || hasData;

                let visible = normallyVisible;
                visible = isInterrestrateVisible(visible, interestActive);
                visible = isExcercisePriceVisible(visible, exerciseActive);

                if (visible) {
                    const normallyRequired = isRequired(
                            source,
                            formData.instrumentCategory,
                            formData.preliminaryTerms,
                            formData.interestType,
                            formData.preliminaryTerms,
                            formData.isinStatus,
                            formData.cfiCode
                    );

                    let required = normallyRequired;
                    required = isInterrestrateRequired(required, interestActive);
                    required = isExcercisePriceRequired(required, exerciseActive);

                    props.required = required;

                    return cloneElement(childElement, { ...props, source });
                } else {
                    return null;
                }
            }}
        </FormDataConsumer>
    } else {
        return cloneElement(childElement, { ...props, source });
    }
};

export default ConditionalInput;

